import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { aiAssistantApiRef, AiAssistantClient } from './api';

/**
 * AI Assistant frontend plugin
 * 
 * Provides a conversational chat interface for interacting with the
 * KONE Developer Portal's AI Assistant.
 */
export const aiAssistantPlugin = createPlugin({
  id: 'ai-assistant',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: aiAssistantApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AiAssistantClient(discoveryApi, fetchApi),
    }),
  ],
});

/**
 * Main page component for the AI Assistant
 */
export const AiAssistantPage = aiAssistantPlugin.provide(
  createRoutableExtension({
    name: 'AiAssistantPage',
    component: () =>
      import('./components/ChatInterface').then(m => m.ChatInterface),
    mountPoint: rootRouteRef,
  }),
);
